export const CLAIM_EDIT_VALIDATOR_FIELD = "EditValidatorFields";
export const CLAIM_EDIT_CREATOR_FIELD = "CanCreateEditDocument";
export const CLAIM_APPROVER = "ViewDocumentForApprover";
export const CLAIM_MDT_VALIDATOR = "TransitionProcessedFinalized";
